module.exports = __webpack_public_path__ + "static/fonts/SourceSans3-VariableFont_wght.7b50649.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceSans3-VariableFont_wght.ttf
// module id = 873
// module chunks = 119